import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../../utils/Axios";
import { GET_READY_TO_INCISION_LAG_QUERY_KEY } from "../types/CommonTypes";
import { GET_READY_TO_INCISION_LAG_SUMMARY_RESPONSE } from "../types/ResponseTypes";

async function getReadyToIncisionLag(tenantId: string, hospitalId: string, queryString: string): Promise<GET_READY_TO_INCISION_LAG_SUMMARY_RESPONSE> {
  const { data } = await fetcher({
    url: `analytics/ready-to-incision-lag?${queryString}`,
    headers: {
      "x-tenant-id": tenantId,
      "x-hospital-id": hospitalId,
    },
  });
  return data;
}

function useGetReadyToIncisionLagQuery(tenantId: string, hospitalId: string, queryString: string = "") {
  return useQuery({
    queryKey: [
      GET_READY_TO_INCISION_LAG_QUERY_KEY,
      queryString,
      tenantId,
      hospitalId,],
    queryFn: () => getReadyToIncisionLag(tenantId, hospitalId, queryString),
    refetchInterval: 60000,
  });
}

export default useGetReadyToIncisionLagQuery;
